// V1 API Imports
import * as ContentDeliveryApiNS from '../ContentDeliveryAPI';
import * as ActionResponseNS from '../Models/ActionResponse';
import * as IContentNS from '../Models/IContent';
import * as FetchAdapterNS from '../ContentDelivery/FetchAdapter';

// V2 API Imports
import * as IContentRepositoryNS from '../Repository/IContentRepository';
import * as IIContentRepositoryNS from '../Repository/IIContentRepository';
import * as IContentDeliveryApiNS from '../ContentDelivery/IContentDeliveryAPI';
import * as ContentDeliveryApiV2NS from '../ContentDelivery/ContentDeliveryAPI';
import * as IContentDeliveryApiConfigNS from '../ContentDelivery/Config';
import * as DefaultAuthServiceNS from '../ContentDelivery/DefaultAuthService';
import * as IAuthServiceNS from '../ContentDelivery/IAuthService';
import * as IAuthStorageNS from '../ContentDelivery/IAuthStorage';
import * as IAuthTokenProviderNS from '../ContentDelivery/IAuthTokenProvider';
import * as BrowserAuthStorageNS from '../ContentDelivery/BrowserAuthStorage';
import * as ServerAuthStorageNS from '../ContentDelivery/ServerAuthStorage';

// V1 API Exports
export import PathResponseIsIContent = ContentDeliveryApiNS.PathResponseIsIContent;
export import PathResponseIsActionResponse = ContentDeliveryApiNS.PathResponseIsActionResponse;
export import namePropertyIsString = IContentNS.namePropertyIsString;
/**
 * @deprecated Please switch to the V2 API
 */
export import DefaultAPI = ContentDeliveryApiNS.ContentDeliveryAPI;
/**
 * @deprecated Please switch to the V2 API
 */
export import API = ContentDeliveryApiNS.ContentDeliveryAPI;
export import NetworkErrorData = ContentDeliveryApiNS.NetworkErrorData;
export import PathResponse = ContentDeliveryApiNS.PathResponse;
export import ActionResponse = ActionResponseNS.ActionResponse;

// Content delivery response modelling
export * from '../Property';

// V2 API
export import CachingFetchAdapter = FetchAdapterNS.CachingFetchAdapter;
export import FetchAdapter = FetchAdapterNS.FetchAdapter;
export import IContentDeliveryAPI_V2 = IContentDeliveryApiNS.IContentDeliveryAPI;
export import ConfigV2 = IContentDeliveryApiConfigNS.Config;
export import IIContentRepositoryV2 = IIContentRepositoryNS.IIContentRepository;
export import RepositoryV2 = IContentRepositoryNS.IContentRepository;
export import DefaultAPI_V2 = ContentDeliveryApiV2NS.ContentDeliveryAPI;
export import API_V2 = ContentDeliveryApiV2NS.ContentDeliveryAPI;
export import isNetworkError = IContentDeliveryApiNS.isNetworkError;

export * from '../Repository/IRepository';

// V2 Auth API
export import IAuthService = IAuthServiceNS.IAuthService
export import IAuthServiceStatic = IAuthServiceNS.IAuthServiceStatic
export import IOAuthRequest = IAuthServiceNS.IOAuthRequest
export import IOAuthResponse = IAuthServiceNS.IOAuthResponse
export import IOAuthErrorResponse = IAuthServiceNS.IOAuthErrorResponse
export import IOAuthSuccessResponse = IAuthServiceNS.IOAuthSuccessResponse
export import IAuthStorage = IAuthStorageNS.IAuthStorage
export import IAuthToken = IAuthTokenProviderNS.IAuthToken
export import IAuthTokenProvider = IAuthTokenProviderNS.IAuthTokenProvider
export import DefaultAuthService = DefaultAuthServiceNS.DefaultAuthService
export import BrowserAuthStorage = BrowserAuthStorageNS.BrowserAuthStorage
export import ServerAuthStorage = ServerAuthStorageNS.ServerAuthStorage